export const API_URL = process.env.VUE_APP_API_SERVICE_URL;
export default API_URL;
